// extracted by mini-css-extract-plugin
export default {"widgetSubHeading":"KjNydvlPMu0zuE3gfE5p"};